import React from "react";
import { PromoBar } from "@/components/PromoBar";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Services } from "@/components/Services";
import { Gallery } from "@/components/Gallery";
import { About } from "@/components/About";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";
import { BookingModal } from "@/components/BookingModal";
import { PROMO } from "@/lib/data";

const STORAGE_KEY = "dt_promo_dismissed";

export default function Landing() {
  const [bookingOpen, setBookingOpen] = React.useState(false);
  const [preselected, setPreselected] = React.useState(null);
  const [startStep, setStartStep] = React.useState(0);
  const [promoActive, setPromoActive] = React.useState(false);

  // Sync promo bar visibility for layout offsetting the navbar
  const [promoVisible, setPromoVisible] = React.useState(PROMO.enabled);
  React.useEffect(() => {
    if (typeof window === "undefined") return;
    const dismissed = localStorage.getItem(STORAGE_KEY) === "1";
    setPromoVisible(PROMO.enabled && !dismissed);
    const observer = new MutationObserver(() => {
      const stillThere = !!document.querySelector('[data-testid="promo-bar"]');
      setPromoVisible(stillThere);
    });
    observer.observe(document.body, { childList: true, subtree: true });
    return () => observer.disconnect();
  }, []);

  const openBooking = (serviceId = null) => {
    setPreselected(serviceId);
    setStartStep(0);
    setPromoActive(false);
    setBookingOpen(true);
  };

  const claimPromo = () => {
    setPreselected(PROMO.serviceId);
    setStartStep(1); // jump straight to the Vehicle step (skip service selection)
    setPromoActive(true);
    setBookingOpen(true);
  };

  const navbarOffset = promoVisible ? 44 : 0;

  return (
    <div className="min-h-screen bg-white" data-testid="landing-page">
      <PromoBar onClaim={claimPromo} />
      <Navbar onBookClick={() => openBooking()} topOffset={navbarOffset} />
      <Hero onBookClick={() => openBooking()} />
      <Services onBookService={(id) => openBooking(id)} />
      <Gallery />
      <About />
      <Contact onBookClick={() => openBooking()} />
      <Footer />

      <BookingModal
        open={bookingOpen}
        onOpenChange={setBookingOpen}
        preselectedService={preselected}
        startStep={startStep}
        promo={promoActive}
      />
    </div>
  );
}
